export default __webpack_public_path__ + "static/media/icon-home.d65b27da.png";